package io.github.amanshuraikwar.portfolio.model

data class ExperienceData(
    val title: String,
    val location: String,
    val dateRange: String,
    val content: List<String>,
)